export default "__VITE_ASSET__BbVJD0Xa__"